import React, { useEffect, useState } from "react";
import {
    Col,
    Container,
    Row,
    Button,
    Card,
    CardHeader,
    CardBody,
    Input,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Badge
} from "reactstrap";
import { historyService } from "services";

import FormControl from '@material-ui/core/FormControl';
import { MenuItem } from "@material-ui/core";
import Select from '@material-ui/core/Select';
import { makeStyles } from '@material-ui/core/styles';
import LoaderBox from "../components/custom/loader/loaderBox";

const useStyles = makeStyles((theme) => ({
    formControl: {
        minWidth: 120,
        backgroundColor: '#fff',
        borderRadius: '0.375rem',
        '& .MuiOutlinedInput-root': {
            height: '40px',
        }
    },
}));

const HistoryPage = () => {
    const [historyData, setHistoryData] = useState([]);
    const [filterState, setFilterState] = useState(false);
    const [loader, setLoader] = useState(false);

    const closeFilterMode = () => {
        const getHistoric = () => {
            setLoader(true);
            historyService.list().then((response) => {
                setHistoryData(response.data.results);
                setLoader(false);
            }).catch((error) => {
                console.error(error);
                setLoader(false);
            });
        }

        getHistoric();
        setFilterState(false);
    }

    useEffect(() => {
        const getHistoric = () => {
            setLoader(true);
            historyService.list().then((response) => {
                setHistoryData(response.data.results);
                setLoader(false);
            }).catch((error) => {
                console.error(error);
                setLoader(false);
            });
        }

        getHistoric();
    }, []);

    const HistoricItem = ({...props}) => {
        let { historic } = props;

        const [historyState, setHistoryState] = useState(false);
        const openHistory = () => setHistoryState(true);
        const closeHistory = () => setHistoryState(false);

        const formatDateTime = (datetime) => {
            if (!datetime) return "N/A";
            const dt = datetime.split("T");
            const date = dt[0].split("-");
            const timeZone = dt[1].split(".");
            const time = timeZone[0].split(":");

            return `${date[2]}/${date[1]}/${date[0]} ${time[0]}:${time[1]}`;
        }

        let historicItens = []
        let ordenedHistoric = {...historic}
        const historicSO = ordenedHistoric.SO
        const historicPage = ordenedHistoric.page
        ordenedHistoric = Object.assign({}, ordenedHistoric, { idHistoric: true });

        historicItens = historicItens.concat(ordenedHistoric.so_item || [])
        historicItens.push(ordenedHistoric);
        historicItens.sort((a, b) => new Date(b.datetime) - new Date(a.datetime));
        
        delete ordenedHistoric["so_item"];
        delete ordenedHistoric["page"];
        delete ordenedHistoric["SO"];

        historic = historicItens[0];
        delete historic.idHistoric;

        historicItens.splice(0, 1);

        historic.page = historicPage;
        historic.SO = historicSO;
        historic.so_item = historicItens;

        const datetime = formatDateTime(historic.datetime);
        const user = historic.user.first_name && historic.user.last_name 
            ? `${historic.user.first_name} ${historic.user.last_name}` 
            : `${historic.user.username}`;

        const ChangeItem = ({...props}) => {
            const before = props.data.before;
            const afterValues = props.data.after;
            const user = props.data.user.first_name && props.data.user.last_name 
                ? `${props.data.user.first_name} ${props.data.user.last_name}` 
                : `${props.data.user.username}`;

            return (
                <div 
                    className="p-3 border-bottom"
                    style={{
                        backgroundColor: props.index % 2 === 0 ? "#f8f9fe" : "#fff",
                    }}
                >
                    <Row className="align-items-center">
                        <Col md="6" className="text-center border-right">
                             <Badge color="danger" pill className="mb-2">Anterio</Badge>
                             <div className="text-muted small">
                                {before && before.length > 0 ? before : "Sem histórico anterior."}
                             </div>
                        </Col>
                        <Col md="6" className="text-center">
                            <Badge color="success" pill className="mb-2">Novo Valor</Badge>
                            <div className="text-dark font-weight-600 small">
                                {afterValues}
                            </div>
                        </Col>
                    </Row>
                    {props.data.idHistoric && (
                        <div className="mt-3 pt-2 border-top text-center small text-muted font-italic">
                            <span className="mx-2"><i className="ni ni-settings mr-1" /><strong>Ação:</strong> {props.data.action}</span>
                            <span className="mx-2"><i className="ni ni-single-02 mr-1" /><strong>Usuário:</strong> {user}</span>
                            <span className="mx-2"><i className="ni ni-calendar-grid-58 mr-1" /><strong>Data:</strong> {formatDateTime(props.data.datetime)}</span>
                        </div>
                    )}
                </div>
            )
        }

        return (
            <>
                <tr className="hover-light">
                    <td className="px-4 py-3">
                        <div className="d-flex align-items-center">
                            <div className="avatar avatar-sm rounded-circle bg-secondary mr-3 text-primary">
                                <i className="ni ni-single-02" />
                            </div>
                            <div>
                                <span className="mb-0 text-sm font-weight-700 text-dark d-block">{user}</span>
                                <span className="text-muted small">{historic.user.email}</span>
                            </div>
                        </div>
                    </td>
                    <td className="px-4 py-3">
                        <div className="d-flex flex-column">
                            <span className="text-dark text-sm font-weight-600">{historic.page}</span>
                            <span className="text-muted small">Módulo</span>
                        </div>
                    </td>
                    <td className="px-4 py-3 text-center">
                        <Badge color="info" outline className="text-uppercase px-3" style={{ fontSize: '0.65rem' }}>
                            {historic.action}
                        </Badge>
                    </td>
                    <td className="px-4 py-3 text-center">
                        <span className="text-muted small font-weight-600">{datetime}</span>
                    </td>
                    <td className="px-4 py-3 text-center">
                        {historic.SO ? (
                            <Badge color="secondary" className="text-dark">{historic.SO}</Badge>
                        ) : (
                            <span className="text-muted opacity-5 small">-</span>
                        )}
                    </td>
                    <td className="px-4 py-3 text-right">
                        <Button 
                            color={historyState ? "primary" : "secondary"}
                            outline
                            size="sm" 
                            onClick={historyState ? closeHistory : openHistory}
                            className="btn-icon-only rounded-circle"
                        >
                            <i className={historyState ? "ni ni-bold-up" : "ni ni-bold-down"} />
                        </Button>
                    </td>
                </tr>
                {historyState && (
                    <tr>
                        <td colSpan="6" className="p-0 border-0 bg-secondary-lighter">
                            <div className="m-3 shadow-inner rounded overflow-hidden border">
                                <div className="bg-white p-2 border-bottom d-flex justify-content-between align-items-center">
                                    <span className="text-primary font-weight-700 small px-2">DETALHES DA ALTERAÇÃO</span>
                                    <Button size="xs" color="link" className="text-muted" onClick={closeHistory}>Fechar</Button>
                                </div>
                                <ChangeItem data={historic} index={0}/>
                                {historic.so_item.map((soHistoric, index) => (
                                    <ChangeItem data={soHistoric} key={`detail-${index}`} index={index + 1}/>
                                ))}
                            </div>
                        </td>
                    </tr>
                )}
            </>
        )
    }

    const Filter = () => {
        const [selectValue, setSelectValue] = useState(undefined);
        const [filterValue, setFilterValue] = useState("");
        const classes = useStyles();

        const filters = [
            ["Usuário", "idUser"],
            ["Processo (SO)", "SO"],
            ["Ação", "action"],
            ["Página", "page_search"]
        ];

        const handlerSelect = (e) => setSelectValue(e.target.value);
        const handlerInput = (e) => setFilterValue(e.target.value);

        const searchFilter = () => {
            if(!selectValue) return;
            if(filterValue.length < 1) return;
            setLoader(true);
            historyService.filter({ [selectValue]: filterValue }).then((response) => {
                setHistoryData(response.data.results);
                setLoader(false);
            }).catch((error) => {
                console.error(error);
                setLoader(false);
            });
            setFilterState(true);
        }

        return (
            <Card className="shadow-sm border-0 mb-4 bg-secondary-lighter">
                <CardBody className="py-3">
                    <Row className="align-items-center">
                        <Col md="1" className="text-center">
                            <i className="ni ni-zoom-split-in text-primary display-4 opacity-5" />
                        </Col>
                        <Col md="3">
                            <FormControl variant="outlined" size="small" fullWidth className={classes.formControl}>
                                <Select
                                    value={selectValue}
                                    onChange={handlerSelect}
                                    displayEmpty
                                >
                                    <MenuItem value={undefined}>
                                        <em className="text-muted">Filtrar por...</em>
                                    </MenuItem>
                                    {filters.map((fill, index) => (
                                        <MenuItem key={`fill-${index}`} value={fill[1]}>
                                            {fill[0]}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Col>
                        <Col md="5">
                            <InputGroup className="input-group-merge">
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText className="bg-white border-right-0">
                                        <i className="ni ni-single-copy-04" />
                                    </InputGroupText>
                                </InputGroupAddon>
                                <Input 
                                    className="border-left-0 pl-0"
                                    type="text" 
                                    onChange={handlerInput} 
                                    placeholder="Digite o termo de busca..." 
                                    value={filterValue} 
                                />
                            </InputGroup>
                        </Col>
                        <Col md="3" className="d-flex">
                            <Button color="primary" block onClick={searchFilter} className="shadow-none">
                                Filtrar
                            </Button>
                            {filterState && (
                                <Button color="secondary" outline className="ml-2" onClick={closeFilterMode}>
                                    <i className="ni ni-refresh-02" />
                                </Button>
                            )}
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        )
    }

    return (
        <div className="content">
            <Container fluid>
                <Row className="mb-4 align-items-center">
                    <Col>
                        <h2 className="mb-0 text-dark" style={{ fontWeight: "700" }}>
                            <i className="ni ni-archive-2 text-primary mr-2" />
                            Histórico de Atividades
                        </h2>
                        <p className="text-muted mb-0 small">Auditoria de alterações realizadas por usuários e subprocessos.</p>
                    </Col>
                </Row>

                <Filter />

                <Row>
                    <Col>
                        <Card className="shadow-sm border-0">
                            <CardHeader className="bg-transparent border-0 py-3">
                                <h4 className="mb-0 text-muted font-weight-600">Registros Recentes</h4>
                            </CardHeader>
                            <CardBody className="p-0">
                                {loader ? (
                                    <div className="py-5">
                                        <LoaderBox message="Carregando histórico..." />
                                    </div>
                                ) : (
                                    <div className="table-responsive">
                                        <table className="table align-items-center table-flush mb-0">
                                            <thead className="thead-light">
                                                <tr>
                                                    <th scope="col" className="px-4 py-3 text-uppercase font-weight-700 ls-1 small">Usuário</th>
                                                    <th scope="col" className="px-4 py-3 text-uppercase font-weight-700 ls-1 small">Local</th>
                                                    <th scope="col" className="px-4 py-3 text-uppercase font-weight-700 ls-1 small text-center">Ação</th>
                                                    <th scope="col" className="px-4 py-3 text-uppercase font-weight-700 ls-1 small text-center">Data/Hora</th>
                                                    <th scope="col" className="px-4 py-3 text-uppercase font-weight-700 ls-1 small text-center">Processo</th>
                                                    <th scope="col" className="px-4 py-3" />
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {historyData.length === 0 ? (
                                                    <tr>
                                                        <td colSpan="6" className="text-center py-5">
                                                            <div className="opacity-3 mb-3">
                                                                <i className="ni ni-folder-17 display-3" />
                                                            </div>
                                                            <h4 className="text-muted">Nenhum registro de auditoria encontrado.</h4>
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    historyData.map((historic, index) => (
                                                        <HistoricItem key={`h-${index}`} historic={historic} index={index}/>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default HistoryPage;
